import { roundToNearest } from '@/filters';
import { getValue, curry, curryPartner } from './helpers';

function fnPreTaxMemberContributions(modifier) {
  return function PreTaxMemberContributions() {
    const freq = getValue(this, `inferred.PreTaxMemberContributionsFrequency${modifier}`);
    const max = this.results.parameters.concessionalContributionThreshold();
    return roundToNearest(max / freq, 1);
  };
}
export const PreTaxMemberContributions = curry(fnPreTaxMemberContributions);
export const PreTaxMemberContributions2 = curryPartner(fnPreTaxMemberContributions);

function fnPostTaxMemberContributions(modifier) {
  return function PostTaxMemberContributions() {
    const freq = getValue(this, `inferred.PostTaxMemberContributionsFrequency${modifier}`);
    const max = this.results.parameters.nonConcessionalContributionThreshold();
    return roundToNearest(max / freq, 1);
  };
}
export const PostTaxMemberContributions = curry(fnPostTaxMemberContributions);
export const PostTaxMemberContributions2 = curryPartner(fnPostTaxMemberContributions);

function fnOneOffContribution() {
  return function OneOffContribution() {
    return this.results.parameters.maximumOneOffContribution();
  };
}
export const OneOffContribution = curry(fnOneOffContribution);
export const OneOffContribution2 = curryPartner(fnOneOffContribution);

function fnRetirementAge(modifier) {
  return function RetirementAge() {
    return getValue(this, `inputs.RetirementAge${modifier}`);
  };
}
export const RetirementAge = curry(fnRetirementAge);
export const RetirementAge2 = curryPartner(fnRetirementAge);

function fnBeforeRetirementAge(modifier) {
  return function BeforeRetirementAge() {
    let returnAge = getValue(this, `inputs.RetirementAge${modifier}`) - 1;
    if (getValue(this, `inputs.AgeNow${modifier}`) >= (getValue(this, `inputs.RetirementAge${modifier}`) - 1)) {
      returnAge = getValue(this, `inputs.AgeNow${modifier}`) + 1;
    }
    return returnAge;
  };
}
export const BeforeRetirementAge = curry(fnBeforeRetirementAge);
export const BeforeRetirementAge2 = curryPartner(fnBeforeRetirementAge);

function fnPartTimeWorkYearsDuration(modifier) {
  return function PartTimeWorkYearsDuration() {
    const startAge = getValue(this, `inputs.PartTimeWorkFromAge${modifier}`);
    const retirementAge = getValue(this, `inputs.RetirementAge${modifier}`);
    return retirementAge - startAge;
  };
}
export const PartTimeWorkYearsDuration = curry(fnPartTimeWorkYearsDuration);
export const PartTimeWorkYearsDuration2 = curryPartner(fnPartTimeWorkYearsDuration);
